import { Observable } from 'rxjs';
import { SSP, TrafficSource } from '../../../shared/_models/models';
import { FusionApiHttpClient } from '../../../shared/_services/server-clients';

// Traffic source endpoints return plain T directly from the server, not wrapped in ResponseFromServer<T>.
export class TrafficSourcesApiService {
  constructor(private readonly fusionApiHttpClient: FusionApiHttpClient) {}

  getAll(): Observable<TrafficSource[]> {
    return this.fusionApiHttpClient.plain.get<TrafficSource[]>('trafficSource/');
  }

  getById(id: number | string): Observable<TrafficSource> {
    return this.fusionApiHttpClient.plain.get<TrafficSource>(`trafficSource/${id}`);
  }

  create(data: Partial<TrafficSource>): Observable<TrafficSource> {
    return this.fusionApiHttpClient.plain.post<TrafficSource, Partial<TrafficSource>>('trafficSource/', data);
  }

  update(id: number | string, data: Partial<TrafficSource>): Observable<TrafficSource> {
    return this.fusionApiHttpClient.plain.put<TrafficSource, Partial<TrafficSource>>(`trafficSource/${id}`, data);
  }

  delete(id: number | string): Observable<void> {
    return this.fusionApiHttpClient.plain.delete<void>(`trafficSource/${id}`);
  }

  getSspList(): Observable<SSP[]> {
    return this.fusionApiHttpClient.plain.get<SSP[]>('trafficSource/ssp');
  }
}
